import React from 'react';
import { cn, getMeta } from '@/lib/utils';

interface OneVerseLogoProps {
  className?: string;
  isCollapsed?: boolean;
}

// Read once at module load — injected by Rails layout when branding keys are set.
const customLogoUrl: string | null = getMeta('branding-logo-url');
const logoMaxHeightPx: number | null = (() => {
  const raw = getMeta('branding-logo-max-height');
  if (!raw) return null;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
})();

const OneVerseLogo: React.FC<OneVerseLogoProps> = ({ className, isCollapsed }) => {
  const maxH = logoMaxHeightPx ?? 32;

  return (
    <div
      className={cn('flex items-center justify-center', className)}
    >
      <img
        src={
          customLogoUrl && !isCollapsed
            ? customLogoUrl
            : isCollapsed
              ? '/static/oneverse_icon.svg'
              : '/static/oneverse-logo.svg'
        }
        alt={isCollapsed ? 'OneVerse' : 'OneVerse Logo'}
        style={{ height: maxH, width: 'auto', maxWidth: '100%' }}
        className={cn(isCollapsed ? 'w-10' : '')}
      />
    </div>
  );
};

export default OneVerseLogo;
